export default __webpack_public_path__ + "42edb559d45e1be9ba32b0c119416e12.png";